import { SVGProps } from 'react'

export const Maestro = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="27"
      height="17"
      viewBox="0 0 27 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M17.2939 2.30359H10.3223V14.8317H17.2939V2.30359Z" fill="#7375CF" />
      <path
        d="M10.7651 8.56751C10.764 7.36096 11.0374 6.16997 11.5647 5.08471C12.0919 3.99945 12.8591 3.04836 13.8082 2.30344C12.6329 1.37956 11.2213 0.805024 9.73481 0.64548C8.24834 0.485936 6.74697 0.747829 5.4023 1.40122C4.05764 2.05462 2.92394 3.07315 2.13078 4.3404C1.33761 5.60766 0.916992 7.0725 0.916992 8.56751C0.916992 10.0625 1.33761 11.5274 2.13078 12.7946C2.92394 14.0619 4.05764 15.0804 5.4023 15.7338C6.74697 16.3872 8.24834 16.6491 9.73481 16.4895C11.2213 16.33 12.6329 15.7555 13.8082 14.8316C12.8591 14.0867 12.0919 13.1356 11.5647 12.0503C11.0374 10.965 10.764 9.77406 10.7651 8.56751Z"
        fill="#EB001B"
      />
      <path
        d="M25.9383 13.5043V13.2478H26.0417V13.1956H25.7783V13.2478H25.8818V13.5043H25.9383ZM26.4497 13.5043V13.1951H26.3689L26.276 13.4078L26.1832 13.1951H26.1024V13.5043H26.1594V13.271L26.2465 13.4722H26.3056L26.3927 13.2705V13.5043H26.4497Z"
        fill="#00A2E5"
      />
      <path
        d="M26.6994 8.56751C26.6995 10.0625 26.2789 11.5273 25.4858 12.7946C24.6927 14.0618 23.559 15.0804 22.2144 15.7338C20.8697 16.3872 19.3684 16.6491 17.882 16.4895C16.3955 16.33 14.9839 15.7555 13.8086 14.8316C14.7569 14.0859 15.5235 13.1347 16.0507 12.0496C16.5778 10.9645 16.8517 9.77387 16.8517 8.56751C16.8517 7.36115 16.5778 6.17054 16.0507 5.08545C15.5235 4.00036 14.7569 3.04911 13.8086 2.30344C14.9839 1.37956 16.3955 0.80502 17.882 0.645478C19.3684 0.485936 20.8697 0.747834 22.2144 1.40124C23.559 2.05464 24.6927 3.07317 25.4858 4.34043C26.2789 5.60769 26.6995 7.07252 26.6994 8.56751Z"
        fill="#00A2E5"
      />
    </svg>
  )
}
